export const way = [
  { label: '电话', value: 1 },
  { label: 'QQ', value: 2 },
  { label: '微信', value: 3 },
  { label: '来电', value: 4 },
  { label: '其他', value: 5 }
];

export const quickRecord = [
  { label: '电话号码错误，联系其他方式', value: 1 },
  { label: '加QQ未通过~~~~~~~~~~~~~~~~~~~~~', value: 2 },
  { label: '加微信未通过~~~~~~~~~~~~~~~~~~~~~', value: 3 },
  { label: '电话拒绝，短信已发~~~~~~', value: 4 },
  { label: '号码停机~~~~~~~~~~~~~~~~~~~~~', value: 5 },
  { label: '加微信通过留言无回复~~~~~~~~~', value: 6 },
  { label: '添加QQ有验证，不知道验证信息', value: 7 },
  { label: '加QQ通过留言无回复~~~~~~', value: 8 },
  { label: '重复资源，放弃~~~~~~~~~~~~~', value: 9 }
];

export const type = [
  { label: '联系型', value: 1 },
  { label: '跟进型', value: 2 },
  { label: '运营型', value: 3 },
  { label: '活动下发型', value: 21 },
  { label: '客服下发型', value: 22 }
];

export const searchType = [
  { label: '今日', value: 'today' },
  { label: '明日', value: '+1day' },
  { label: '后日', value: '+2day' },
  { label: '7日内', value: '+7day' },
  { label: '全部', value: '' },
];

export const tkPass = [
  { value: -1, label: '全部' },
  { value: 0, label: '待处理' },
  { value: 1, label: '已处理' },
  { value: 2, label: '已取消' }
];

export const quickRecordWriterVisit = [
  { label: '稳定办理中~~~~~~~~~~~~~~~~~', value: 1 },
  { label: '微信/qq未回复，电话联络办理中', value: 2 },
  { label: '微信/qq/电话回复，状态不积极', value: 3 },
  { label: '联络中，材料困难待处理', value: 4 },
  { label: '联络中，家人反对待处理', value: 5 },
  { label: '微信/qq/电话未回复，咨询确认中', value: 6 },
  { label: '微信/qq/电话未回复，文案流程中', value: 7 },
];
